var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"liuyan-out flex-center cursor",attrs:{"tag":"div","to":"/leavemsg"}})}
var staticRenderFns = []

export { render, staticRenderFns }